import * as Icon from "react-feather";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.scss";
import Home from "./pages/Home";
import CommunicationsMediaAndTechnology from "./pages/CommunicationsMediaAndTechnology";
import FinancialServices from "./pages/FinancialServices";
import HealthAndLifeSciences from "./pages/HealthAndLifeSciences";
import Products from "./pages/Products";
import Resources from "./pages/Resources";
import Notebooks from "./pages/Notebooks";
import Other from "./pages/Other";
import Notfound from "./pages/Notfound";

import React, { useEffect, useState } from 'react';
import Amplify, { Hub } from '@aws-amplify/core';
import { Auth } from '@aws-amplify/auth';
import awsconfig from './prod-exports';
// import awsconfig from './dev-exports';
import { ConfirmSignIn, withAuthenticator } from 'aws-amplify-react';

Amplify.configure(awsconfig);

// {SignIn}



function App({signout, user}) {
    
  const [lightMode, setLightMode] = useState(false);

  lightMode
    ? document.body.classList.add("light")
    : document.body.classList.remove("light");

  const handleMode = () => {
    if (!lightMode) {
      setLightMode(true);
      document.body.classList.add("light");
    } else {
      setLightMode(false);
      document.body.classList.remove("light");
    }
  };
    
    return(
      <BrowserRouter basename="/">
      <div className="light-mode">
        <span className="icon">
          <Icon.Sun />
        </span>
        <button
          className={
            lightMode ? "light-mode-switch active" : "light-mode-switch"
          }
          onClick={() => handleMode()}></button>
      </div>
      <Switch>
        <Route path="/" exact>
          <Home lightMode={lightMode} />
        </Route>

        <Route path="/communications-media-and-technology" exact>
          <CommunicationsMediaAndTechnology lightMode={lightMode} />
        </Route>

        <Route path="/financial-services" exact>
          <FinancialServices lightMode={lightMode} />
        </Route>

        <Route path="/health-and-life-sciences" exact>
          <HealthAndLifeSciences lightMode={lightMode} />
        </Route>

        <Route path="/products" exact>
          <Products lightMode={lightMode} />
        </Route>

        <Route path="/resources" exact>
          <Resources lightMode={lightMode} />
        </Route>

        <Route path="/notebooks" exact>
          <Notebooks lightMode={lightMode} />
        </Route>

        <Route path="/other" exact>
          <Other lightMode={lightMode} />
        </Route>


        <Route path="*" component={Notfound} />

      </Switch>
    </BrowserRouter>)
  }

// This is my custom Sign in component
function MySignIn({ onStateChange }) {

  const [user, setUser] = useState(null);

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          getUser().then(userData => {
            setUser(userData);
            if (userData) onStateChange('signedIn', userData);
          });
          break;
        case 'signOut':
          setUser(null);
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          console.log('Sign in failure', data);
          break;
      }
    });

    getUser().then(userData => {
      setUser(userData);
      if (userData) {
        onStateChange('signedIn', userData);
      } else {
        Auth.federatedSignIn();
      }
    });
  }, []);

  function getUser() {
    return Auth.currentAuthenticatedUser()
      .then(userData => userData)
      .catch(() => console.log('Not signed in'));
  }

  return (

    <div>
  </div>
  );

}
export default withAuthenticator(App, false, [
  <MySignIn/>,
  <ConfirmSignIn/>
]);
